import {DrawerProps} from '@mantine/core';
import {useParams} from "react-router-dom";
import {FormDrawer} from "./FormDrawer.tsx";
import {useApplicationScreenshot} from "../hooks/useApplicationScreenshot.ts";


export const EditFormDrawer = (props: DrawerProps) => {

    const {id: screenshotId} = useParams();

    if (typeof screenshotId === 'undefined') {
        throw new Error('screenshotId is required parameter');
    }

    const {
        record,
        updateRecord,
    } = useApplicationScreenshot(screenshotId);

    if (!record) return null;

    return (
        <FormDrawer
            record={record}
            handleSubmit={updateRecord}
            {...props}
        />
    )
};
